import type { Peer } from "../lib/presence";
import { useOtherPeers } from "../lib/presence";

const GRADIENTS = [
  "linear-gradient(135deg, #00C4F0 0%, #6E2BD9 100%)",
  "linear-gradient(135deg, #FF8A3D 0%, #E0356C 100%)",
  "linear-gradient(135deg, #2EBD85 0%, #0E7E92 100%)",
  "linear-gradient(135deg, #F5C518 0%, #E0356C 100%)",
  "linear-gradient(135deg, #8E6CF5 0%, #00A3FF 100%)",
];

export function gradientFor(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length]!;
}

interface AvatarProps {
  peer: Peer;
  size?: number;
  title?: string;
}

export function PresenceAvatar({ peer, size = 28, title }: AvatarProps) {
  return (
    <div
      className="gf-presence__avatar"
      title={title ?? labelFor(peer)}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        background: gradientFor(peer.user.id),
      }}
    >
      {peer.user.initials}
    </div>
  );
}

function labelFor(peer: Peer): string {
  const loc = peer.location;
  if (loc.screen === "dashboard") return `${peer.user.name} · on dashboard`;
  if (loc.screen === "lesson") {
    return `${peer.user.name} · ${loc.lessonId ?? "lesson"} · step ${
      (loc.step ?? 0) + 1
    }`;
  }
  return peer.user.name;
}

export function PresenceStack({ max = 4 }: { max?: number }) {
  const peers = useOtherPeers();
  if (peers.length === 0) return null;
  const visible = peers.slice(0, max);
  const extra = peers.length - visible.length;
  return (
    <div className="gf-presence__stack" title={`${peers.length} online`}>
      {visible.map((p) => (
        <PresenceAvatar key={p.sessionId} peer={p} />
      ))}
      {extra > 0 && (
        <div className="gf-presence__avatar gf-presence__avatar--more">
          +{extra}
        </div>
      )}
    </div>
  );
}
